import * as actions from 'actions';

const INITIAL_STATE = 0;

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {

    case actions.CHAT_MESSAGES_UPDATE: {
      if(action.initiatedByServer) {
        return action.result.lastChatMessageId;
      }

      return state;
    }

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/chatItems/lastChatMessageId/reducer.js
 **/